export enum PrintStatuses {
  success = 'SUCCESS',
  fail = 'FAIL',
  sent = 'SENT',
  none = '',
}
